var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconSocialUnauthTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 19.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3737 14.6712C13.392 14.5925 13.4105 14.5171 13.4288 14.4452C14.1362 15.3288 14.9918 16.0616 15.9542 16.5998C17.2088 17.3015 18.6039 17.6493 20.0144 17.6087L20.5 17.5947V17.1089V16.2756H20.5L20.5 16.2695C20.4918 15.5957 20.6704 14.9393 21.0064 14.3893C21.3421 13.8398 21.8159 13.4273 22.3568 13.1979C22.8966 12.969 23.4835 12.9305 24.0413 13.0856C24.6 13.2409 25.1114 13.5857 25.5013 14.0838L25.7189 14.3617L26.0536 14.2497C26.4906 14.1035 26.9154 13.9198 27.3241 13.7009C27.065 14.2633 26.7265 14.7771 26.3207 15.2219L26.1558 15.4026L26.1972 15.6437C26.2317 15.8439 26.2494 16.0473 26.25 16.2514C26.2498 20.8933 24.2584 24.1526 21.5267 25.7681C19.2275 27.1279 16.352 27.3556 13.5761 26.2098C14.9065 25.9713 16.1792 25.4126 17.3011 24.5664L17.9486 24.078L17.2214 23.7189C14.049 22.1523 13.1815 19.6365 13.0933 17.4801C13.0488 16.3919 13.2048 15.3969 13.3737 14.6712Z",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSocialUnauthTwitter);
export default __webpack_public_path__ + "static/media/icon_social_unauth_twitter.3f1e2194927c13152ab5967eb665f1d3.svg";
export { ForwardRef as ReactComponent };